
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-064c7efc&scoped=true!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ProductInfoComponent.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductInfoComponent.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-064c7efc!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductInfoComponent.vue"),
  /* scopeId */
  "data-v-064c7efc",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ProductInfoComponent.vue
// module id = 201
// module chunks = 2